<template>
    <div class="mguu-password-form" v-if="app_design_type === 'mguu'">
        <main>
            <MguuInput
                label="Логин"
                type="email"
                disabled
                v-model="user.email"
            />
            <div
                class="password-field-with-rules"
                :class="{ 'show-rules': passwordFocused }"
                @focusin="passwordFocused = true"
                @focusout="passwordFocused = false"
            >
                <MguuInput
                    label="Пароль"
                    type="password"
                    autocomplete="current-password"
                    required
                    v-model="newPassword"
                />
                <password-rules
                    :password-for-check="newPassword"
                    ref="passwordRules"
                    force-show
                />
            </div>
        </main>
        <footer>
            <div class="footer-left">&nbsp;</div>
            <div class="footer-right">
                <div class="footer-right-button-area">
                    <MguuButton
                        @click="send()"
                        label="Далее"
                        :disabled="!newPassword"
                    />
                </div>
            </div>
        </footer>
    </div>
    <div class="auth__fields" v-else>
        <h4 class="auth__subtitle">
            Придумайте постоянный пароль к вашему аккаунту
        </h4>
        <div class="signup__email-view">{{ user.email }}</div>
        <app-input-password
            v-model="newPassword"
            label="Пароль"
            @keyup.enter="send()"
            class="finish-signup__password-field"
        />
        <password-rules :password-for-check="newPassword" ref="passwordRules" />
        <mt-button
            class="auth__actions__btn"
            @click="send()"
            :loading="requestPending"
        >
            <span>Продолжить</span>
        </mt-button>
    </div>
</template>

<script>
import PasswordRules from '@/components/workspace/auth/PasswordRules/index.vue';
import AppInput from '@/components/UI/AppInput/AppInput.vue';
import api from '@/network/index.js';
import AuthApi from '@/api/auth.api.ts';
import mtButton from '@/components/UI/mtButton/index.vue';
import { mapMutations } from 'vuex';
import useToast from '@/components/UI/AppToast/useToast.js';
import AppInputPassword from '@/components/UI/AppInputPassword.vue';
import MguuInput from '@/components/UI/MguuInput.vue';
import MguuButton from '@/components/UI/MguuButton.vue';

export default {
    components: {
        AppInputPassword,
        mtButton,
        PasswordRules,
        AppInput,
        MguuInput,
        MguuButton,
    },
    props: {
        user: Object,
    },
    data() {
        return {
            hidePassword: true,
            newPassword: null,
            requestPending: false,
            passwordFocused: false, 
        };
    },
    methods: {
        ...mapMutations(['UPDATE_USER_DATA']),
        hidePasswordToggle() {
            this.hidePassword = !this.hidePassword;
        },
        send() {
            const { toast } = useToast();
            if (!this.$refs.passwordRules.allRulesAreValid) {
                toast.error('Пароль не соответствует требованиям');
                return;
            }

            this.requestPending = true;
            AuthApi.finishSignUpSetPermanentPassword(this.newPassword)
                .then((response) => {
                    this.$emit('success');
                })
                .finally(() => {
                    this.requestPending = false;
                });
        },
    },
};
</script>

<style lang="scss">
.finish-signup {
    &__password-field {
        margin-bottom: 20px;
    }
}

.mguu-password-form {
    * {
        box-sizing: border-box;
    }

    .password-field-with-rules {
        position: relative;

        .password-rules {
            display: none;
            position: absolute;
            top: calc(100% + 14px);
            left: 0;
            z-index: 10;
            width: max-content;
            margin: 0;
            border-radius: 16px;
            background: #fff;
            border: 1px solid #fff;
            padding: 16px 24px 24px;
            box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);

            &::before {
                content: '';
                position: absolute;
                top: -7px;
                left: 50%;
                transform: translateX(-50%) rotate(45deg);
                width: 14px;
                height: 14px;
                background: #fff;
                border-radius: 2px;
            }

            &__title {
                display: none;
            }

            &__item {
                font-size: 16px;
                line-height: 20px;
                color: #12122c;
                margin: 0;
                margin-bottom: 12px;
                &:last-child {
                    margin-bottom: 0;
                }
            }

            &__item_error,
            &__item_correct,
            &__item_empty {
                color: #12122c;
            }

            &__item__status {
                display: none;
            }
        }

        &.show-rules .password-rules,
        &:focus-within .password-rules {
            display: block;
        }
    }

    main {
        display: flex;
        flex-direction: column;
        gap: 32px;
        margin: auto;
        padding: 23px 36px 28px;
        background-color: rgba(255, 255, 255, 0.7);
        border-radius: 32px 32px 32px 0;
    }

    footer {
        display: grid;
        grid-template-columns: 1fr 200px;

        .footer-left {
            padding: 23px 36px 16px;
            border-radius: 0 0 32px 32px;
            background-color: rgba(255, 255, 255, 0.7);
        }
        .footer-right {
            padding: 0;
            background-color: rgba(255, 255, 255, 0.7);
            display: grid;

            .footer-right-button-area {
                padding: 12px 0 0 12px;
                border-radius: 32px 0 0 0;
                background-color: rgb(244, 244, 245);
            }
        }
    }
}

@media (max-width: 767px) {
    .mguu-password-form {
        main {
            border-radius: 16px 16px 0 0;
            gap: 20px;
            padding: 16px 16px 20px;
        }

        footer {
            display: block;

            .footer-left {
                display: none;
            }

            .footer-right {
                display: block;
                background-color: rgba(255, 255, 255, 0.7);
                border-bottom-right-radius: 16px;
                border-bottom-left-radius: 16px;

                .footer-right-button-area {
                    background-color: transparent;
                    padding: 0 16px 16px;
                }
            }
        }
    }
}
</style>
